module.exports = __webpack_public_path__ + "img/logotipo.300144c7.svg";